import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class NgbDateMomentParserFormatter extends NgbDateParserFormatter {
    constructor(private translate: TranslateService) {
        super();
        // Active la locale française si nécessaire
        moment.locale(this.translate.currentLang || 'fr');
    }

    parse(value: string): NgbDateStruct | null {
        const m = moment(value, 'DD/MM/YYYY');
        return m.isValid() ? { day: m.date(), month: m.month() + 1, year: m.year() } : null;
    }

    format(date: NgbDateStruct | null): string {
        if (!date) {
            return '';
        }
        return moment({ year: date.year, month: date.month - 1, day: date.day }).format('DD/MM/YYYY');
    }
}
